import React from 'react';
import WidgetItem from './WidgetItem';
import { WidgetElement } from '../../types/WidgetElement';

interface WidgetChapterListProps {
    items: WidgetElement[];
}

const WidgetList: React.FC<WidgetChapterListProps> = ({ items }) => {
    return (
        <div className="mt-4">
            {items.map(
                (item, index) =>
                    item.title && (
                        <div key={index}>
                            <WidgetItem item={item} />
                            {index !== items.length - 1 && (
                                <hr className="border-gray-400  border-1 opacity-50 border-dashed" />
                            )}
                        </div>
                    )
            )}
        </div>
    );
};

export default WidgetList;
